module.exports = __webpack_public_path__ + "media/newstyle/images/icon-full-cover-0a76e6293890de7e11f68bbd63e98750.svg";